<template>
    <div class="loading">
        <svg width="191" height="102" viewBox="0 0 191 102" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M50.4487 0V10.1589H13.8216V18.5209H41.7411V28.196H13.8216V37.5256H50.7252V47.6844H0V0H50.4487Z" fill="black"/>
            <path d="M136.731 0L123.324 47.6844H105.08L94.1605 10.8499L82.965 47.6844H65.0661L51.6592 0H65.3425L75.5014 36.2125L86.4895 0H103.559L114.271 36.2816L124.43 0H136.731Z" fill="black"/>
            <path d="M190.424 0V10.1589H153.797V18.5209H181.717V28.196H153.797V37.5256H190.701V47.6844H139.976V0H190.424Z" fill="black"/>
            <path d="M108.79 54.1774C114.503 54.1774 118.88 55.4904 121.92 58.1165C125.007 60.7426 126.551 64.5666 126.551 69.5884C126.551 73.5045 125.652 76.7065 123.855 79.1944C122.105 81.6362 119.571 83.387 116.254 84.4466L128.071 101.862H112.384L101.326 85.5523H13.8216V101.862H0V54.1774H108.79ZM112.591 69.1738C112.591 67.5152 112.107 66.2252 111.14 65.3037C110.218 64.3362 108.49 63.8525 105.956 63.8525H13.8216V75.6699H105.956C108.444 75.6699 110.172 75.1862 111.14 74.2187C112.107 73.2511 112.591 71.9381 112.591 70.2795V69.1738Z" fill="black"/>
            <path d="M131.13 65.3037V54.3156H190.701V65.3037H167.826V102H153.936V65.3037H131.13Z" fill="black"/>
            </svg>

    </div>
</template>
<style scoped>
    .loading{
        height: 100svh;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .loading svg{
        animation : anim 7s linear 0s infinite;
    }
    .loading svg, .loading path{
        fill: light-dark(#000, #fff);
        /* stroke: light-dark(#000, #fff);
        color: light-dark(#000, #fff); */
    }
    @keyframes anim {
        20%{
            scale: 1.05
        }
        25%{
            scale: 1
        }
        30%{
            scale: 1.05
        }
        35%{
            scale: 1
        }
        40%{
            scale: 1.05
        }
        45%{
            scale: 1
        }
        50%{
            scale: 1.05
        }
        55%{
            scale: 1
        }
        60%{
            scale: 1.05
        }
        65%{
            scale: 1
        }
        70%{
            scale: 1.05
        }
        75%{
            scale: 1
        }
        80%{
            scale: 1.05
        }
        85%{
            scale: 1
        }
        100%{
            scale: 1
        }
    }
    img{
        animation: anim 7s linear 0s infinite;
    }
</style>